import { createTheme } from "@mui/material/styles";

const Theme = (mode: "light" | "dark") => {
    const isLight = mode === "light";

    const createdTheme = createTheme({
        palette: {
            mode: mode,
            primary: {
                main: "#F97316",
            },
            secondary: {
                main: "#FDBA74",
            },
            success: {
                main: "#4ADE80",
            },
            text: {
                primary: isLight ? "#1F2937" : "#F3F4F6",
                secondary: isLight ? "#6B7280" : "#9CA3AF",
            },
            background: {
                default: isLight ? "#FFFAF4" : "#1F1B14",
                paper: isLight ? "#FFFFFF" : "#2C241B",
            },
        },

        typography: {
            fontFamily: `'Inter', 'Segoe UI', 'Trebuchet MS', sans-serif`,
            fontSize: 14,
            button: {
                textTransform: "none",
                fontWeight: 500,
            },
            h6: {
                fontWeight: 600,
            },
        },

        components: {
            MuiListItemButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        transition: "background-color 0.2s ease",
                        "&.Mui-selected": {
                            color: "#EA580C",
                            "&:hover": {
                                color: "#F97316",
                            },
                        },
                        "&:hover": {
                            backgroundColor: "#FFF3E0",
                            color: "#F97316",
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        transition: "box-shadow 0.2s ease, background-color 0.2s ease",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: 0,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: 0,
                        },
                    },
                    notchedOutline: {
                        border: 0,
                    },
                },
            },
        },
    });

    return createdTheme;
};

export default Theme;
